// extracted by mini-css-extract-plugin
export default {"DelegateeInfo":"_DelegateeInfo--TQ6tm","Row":"_Row--zhGUH","MessageContainer":"_MessageContainer--qOhtX"};